export const GET_QUESTION_STORIES = '[QUESTION STORIES] GET_QUESTION_STORIES'
export const GET_PACKAGE_LIST = '[QUESTION STORIES] GET_PACKAGE_LIST'
export const GET_GRADES = '[QUESTION STORIES] GET_GRADES'
export const GET_SUBJECT = '[QUESTION STORIES] GET_SUBJECT'
export const GET_TOPIC = '[QUESTION STORIES] GET_TOPIC'
export const GET_SUBTOPIC = '[QUESTION STORIES] GET_SUBTOPIC'
export const GET_LANGUAGES = '[QUESTION STORIES] GET_LANGUAGES'
export const PACKAGE_SET_STATE = 'PACKAGE_SET_STATE'